/* eslint-disable consistent-return */
/* eslint-disable no-nested-ternary */
import moment from 'moment';
// import numeral from 'numeral';

/* eslint-disable radix */
/* eslint-disable array-callback-return */
const isJSON = (text) => {
  try {
    const obj = JSON.parse(text);
    return obj === Object(obj) && Object.prototype.toString.call(obj) !== '[object Array]';
  } catch (error) {
    return false;
  }
};

// convert object to array, preserve the keys
const toArray = obj => Object.keys(obj).map(key => ({ key, value: obj[key] }));

const locale = currentLocale => (currentLocale === 'EN' ? 'EN' : 'عربي');

const stringBuilder = (obj) => {
  let result = '';
  Object.keys(obj).map((key, index) => {
    if (obj[key] && obj[key] !== '' && index < Object.keys(obj).length - 1) {
      result += `${[key]}=${obj[key]};`;
    } else if (obj[key] && obj[key] !== '' && index === Object.keys(obj).length - 1) {
      result += `${[key]}=${obj[key]}`;
    }
  });
  return result;
};

const yearBuilder = (str, option) => {
  const n = parseInt(str);
  if (n === 1) {
    return `${n} ${option.singular}`;
  } if (n > 1) {
    return `${n} ${option.plural}`;
  }
  return str;
};

const formatDecimalToPercentage = (value) => {
  const percentage = Number(value) * 100;
  return `${parseInt(percentage)} %`;
};

const formatDate = date => moment(date).locale('en').format('D MMM YYYY');
const formatDateToYears = date => moment(date).locale('en').format('YYYY');

/**
 * is app running as PWA
 */
const isInStandaloneMode = () => (window.matchMedia('(display-mode: standalone)').matches) || (window.navigator.standalone) || document.referrer.includes('android-app://');

const formatNumber = (value) => {
  if (Number.isNaN(parseFloat(value))) return '';
  return new Intl.NumberFormat('en', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

/**
 * format NAV/Unit
 * @param {*} value
 */
const formatNavUnit = (value) => {
  if (Number.isNaN(parseFloat(value))) return '';
  return new Intl.NumberFormat('en', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

const format3yPerformance = value => (value <= 0 ? `${formatNavUnit(value)} %` : `+ ${formatNavUnit(value)} %`);

/**
 * format net assets
 * @param {*} value
 */
const formatUnitCurrency = (value, currency) => {
  if (value && !Number(value) <= 0) {
    return Math.abs(Number(value)) >= 1.0e+9 ? `${currency} ${formatNumber(Number(value) / 1.0e+9)} bil.`
      : Math.abs(Number(value)) >= 1.0e+8 ? `${currency} ${formatNumber(Number(value) / 1.0e+8)} bil.`
        : Math.abs(Number(value)) >= 1.0e+7 ? `${currency} ${formatNumber(Number(value) / 1.0e+7)} bil.`
          : Math.abs(Number(value)) >= 1.0e+6 ? `${currency} ${formatNumber(Number(value) / 1.0e+6)} bil.`
            : `${currency} ${formatNumber(value)}`;
  }
  if (Number(value) <= 0 || !Number(value)) {
    return '-';
  }
};

const ultilitiesService = {
  isJSON,
  toArray,
  locale,
  stringBuilder,
  yearBuilder,
  formatDate,
  formatDateToYears,
  formatDecimalToPercentage,
  isInStandaloneMode,
  formatNumber,
  formatUnitCurrency,
  formatNavUnit,
  format3yPerformance,
};

export default ultilitiesService;
